import { getJurisdictions } from './jurisdiction.backend';
import { put, select } from 'redux-saga/effects';
import * as _ from 'lodash';
import { makeErrorPayload } from '../../shared/helpers/payload.helper';
import { setErrorToast } from '../../shared/toast/redux/actions';
import {
    fetchJurisdictionsFail,
    fetchJurisdictionsSuccess,
    setJurisdiction
} from './actions';
import { fetchStats } from '../../main/main-content/dashboard/redux/actions';
import {
    getBrandsAndJurisdictions,
    getSelectedBrand,
    getSelectedJurisdiction
} from './selectors';

/* Whether the selection is still something the list has: a jurisdiction (or none: all) and, if one is selected, its brand. */
const isStillListed = ({ jurisdiction, brand }, { jurisdictions, brands }) =>
    (!jurisdiction ||
        !jurisdiction.code ||
        _.some(jurisdictions, j => j.code === jurisdiction.code)) &&
    (!brand || _.some(brands, b => b.id === brand.id));

export function* fetchJurisdictionsSaga(action) {
    const keepSelection = !!(action.payload && action.payload.keepSelection);

    try {
        const response = yield getJurisdictions();
        yield put(fetchJurisdictionsSuccess(response.data));

        const selection = {
            jurisdiction: yield select(getSelectedJurisdiction),
            brand: yield select(getSelectedBrand)
        };
        // When the list is read again to pick up a change, the selection is only dropped if what it names has gone (a deleted sandbox)
        if (!keepSelection || !isStillListed(selection, response.data)) {
            yield put(setJurisdiction({ jurisdiction: null, brand: null }));
        }
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchJurisdictionsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* setJurisdictionSaga(action) {
    yield put(fetchStats({ clearOldStats: true }));
}

export function* setJurisdictionByCodeSaga(action) {
    const { jurisdictions } = yield select(getBrandsAndJurisdictions);

    const jurisdiction = jurisdictions.find(j => j.code === action.payload);

    yield put(setJurisdiction({ jurisdiction, brand: null }));
}
